"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAscTimePeriodArray = void 0;
const common_1 = require("../../common");
/** returns true if array has more than zero time perions and each time period is in order, otherwise false */
const isAscTimePeriodArray = (x) => {
    let isTPArr = false;
    if (!!x && x instanceof Array) {
        const arr = x;
        if (arr.length > 0 && arr.every(common_1.isTimePeriod)) {
            isTPArr = arr.reduce((a, c, i, arr) => {
                if (i > 0) {
                    const last = arr[i - 1];
                    a = a && last.toDateMs < c.fromDateMs;
                }
                return a;
            }, true);
        }
    }
    return isTPArr;
};
exports.isAscTimePeriodArray = isAscTimePeriodArray;
